module.exports = __webpack_public_path__ + "img/icon-message.576209f0.svg";